import { render, staticRenderFns } from "./ModalUploadTaxCoreFile.vue?vue&type=template&id=6b05e406&scoped=true&"
import script from "./ModalUploadTaxCoreFile.vue?vue&type=script&lang=js&"
export * from "./ModalUploadTaxCoreFile.vue?vue&type=script&lang=js&"
import style0 from "./ModalUploadTaxCoreFile.vue?vue&type=style&index=0&id=6b05e406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05e406",
  null
  
)

export default component.exports